import React from 'react';
import { useSelector } from 'react-redux';

import ListItem from 'components/ListItem';
import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerProducts/types';
import { FertilizerEntityIds } from 'services/fertilizerEvents/types';
import { makeSelectTotalTrees } from './selectors';

export interface Props {
    productId: FertilizerProductId;
    entityIds: FertilizerEntityIds;
}

export default function FertilizerEventTotalTreesListItem(
    props: Props
): React.ReactElement {
    const totalTrees = useSelector((state: AppState) =>
        makeSelectTotalTrees()(state, props)
    );

    return <ListItem value={totalTrees} description="Total trees" />;
}
